import './promo.css';
import promoImg from './../../img/images/header-img.jpg';

const Promo = () => {
   return (
      <section className="promo">
         <div className="container">
            <div className="promo__content">
               <div className="promo__text">LET’S <br /> EXPLORE <br /> <span className='promo__text-bg'><span>UNIQUE</span></span> <br /> CLOTHES.
                  <p className="promo__sub-text">Live for Influential and Innovative!</p>
                  <div className="promo__btn">
                     <a href="#!" className="promo__link">Shop</a>
                  </div>
               </div>
               <div className="promo__img">
                  <img src={promoImg} alt="" />
               </div>
            </div>
         </div>
      </section>
   );
}

export default Promo;